// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import GoldTwoToneSvg from "@fishx/icons-svg/es/asn/GoldTwoTone";
import FishxIcon from '../components/FishxIcon';

var GoldTwoTone = function GoldTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: GoldTwoToneSvg
  }));
};

GoldTwoTone.displayName = 'GoldTwoTone';
export default React.forwardRef(GoldTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/GoldTwoTone.js
// module id = 2881
// module chunks = 0